import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {ContractDto} from "./contract.dto";
import {CfPayFrequencyDto} from "../../../../../feature-misc/cf/model/dto/entity/cf-pay-frequency.dto";
import {CfPaymentTypeDto} from "../../../../../feature-misc/cf/model/dto/entity/cf-payment-type.dto";
import {CfPaymentMomentDto} from "../../../../../feature-misc/cf/model/dto/entity/cf-payment-moment.dto";

export class ContractPaymentDto extends DtoDetail{


    public contractDto? : ContractDto;
    public contractDtoId : number;
    public contractDtoName : string;
    public startDate: Date;
    public firstPaymentDate: Date;
    public payFrequencyDto? : CfPayFrequencyDto;
    public payFrequencyDtoId : number;
    public payFrequencyDtoName : string;
    public paymentTypeDto? : CfPaymentTypeDto;
    public paymentTypeDtoId : number;
    public paymentTypeDtoName : string;
    public paymentMomentDto? : CfPaymentMomentDto;
    public paymentMomentDtoId : number;
    public paymentMomentDtoName : string;

}